import React from 'react';

const NoDataContent = ({reportData, data, customMessage = null, className = ''}) => {
    return (
        <>
            { reportData && data === 0 && (
                <div id="noDataMessage" className={`alert alert-info p-2 h6 text-center ${className}`}>
                    { customMessage ? customMessage : `Nenhum registro encontrado no período informado.` }
                </div>
            )}
        </>
    );
};

export default NoDataContent;